// ======================================================================
// File: currentStockService.js
// Purpose: API calls for Current Stock Report
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/inventory/reports";

export const fetchCurrentStock = async (filters = {}) => {
  const response = await axiosClient.get(
    `${BASE_URL}/current-stock`,
    { params: filters }
  );

  return response.data?.data || { rows: [], total_rows: 0 };
};

export const exportCurrentStockExcel = async (filters = {}) => {

  const response = await axiosClient.get(
    `${BASE_URL}/current-stock/excel`,
    {
      params: filters,
      responseType: "blob"
    }
  );

  return response.data;
};
